<supplier-schedule-dialog
  [price]="supplierPrice"
  [jobId]="jobId"
  [taskScheduleSource]="taskScheduleSource"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (confirm)="acceptJob($event)"
  finalBtnText="Grab Job"
  [referrPage]="referrPage"
>
</supplier-schedule-dialog>
